export default function() {
    const self = this

    if (self.$store.state.sidebarShow) {
        self.$store.commit('toggleSidebarDesktop')
    }
    self.loadSurvey()
}
